import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PageProps, PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {PARTYCATEGORY, PARTYROLE} from "party/partyDomain";
import {loc} from "core/common/config/locales";

const gridLocation = 'partySuppliers';

@observer
export default class SupplierList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = loc.i18n`Suppliers`;
  static icon = 'male';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("SupplierList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }




  render() {
    let {params, query} = this.props;


    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           multiUpdateSecurable={SECURABLE.partyGridUpdate} >
          <ZzFlatButtonRoute onGridToolbar routeName="partyDetail" params={{id: 'new'}} query={{partyCategory: PARTYCATEGORY.CO, roles:PARTYROLE.SUPPLIER_ROLE}} label="New Supplier" permission={PERMISSION.New}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/party/page/supplierList.tsx